import React from 'react';
import PageLayout from '@components/layout/PageLayout';
import EvidenceReviewDashboard from '@components/features/evidence/EvidenceReviewDashboard';

const EvidenceReviewPage: React.FC = () => {
  return (
    <PageLayout>
      <EvidenceReviewDashboard />
    </PageLayout>
  );
};

export default EvidenceReviewPage;
